import { normalizeEmail } from './onboardingValidation.js';

const STORAGE_KEY = 'bildit.onboarding.trialStarted';

/**
 * Persist trial-started navigation state so a refresh on step 4 keeps the handoff URL.
 * @param {string} email
 * @param {Record<string, unknown>} state
 */
export function persistTrialStartedState(email, state) {
  const normalizedEmail = normalizeEmail(email);
  if (!normalizedEmail || typeof sessionStorage === 'undefined') {
    return;
  }
  try {
    sessionStorage.setItem(
      STORAGE_KEY,
      JSON.stringify({
        email: normalizedEmail,
        ...state,
        savedAt: Date.now(),
      })
    );
  } catch {
    // Private mode / quota — non-fatal.
  }
}

/**
 * @param {string} email
 * @returns {Record<string, unknown> | null}
 */
export function readTrialStartedState(email) {
  const normalizedEmail = normalizeEmail(email);
  if (!normalizedEmail || typeof sessionStorage === 'undefined') {
    return null;
  }
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    if (!raw) {
      return null;
    }
    const parsed = JSON.parse(raw);
    if (normalizeEmail(parsed?.email) !== normalizedEmail) {
      return null;
    }
    return parsed;
  } catch {
    return null;
  }
}

/** @param {string} email @returns {string} */
export function readTrialStartedHandoffUrl(email) {
  const stored = readTrialStartedState(email);
  return String(stored?.handoffUrl || '').trim();
}

/** User-facing copy when the tutorial handoff link is unavailable. */
export const TRIAL_STARTED_HANDOFF_LOADING_TOOLTIP =
  'Preparing your tutorial link…';

export const TRIAL_STARTED_HANDOFF_DISABLED_TOOLTIP =
  'We could not load your tutorial link. Refresh the page or contact support.';
